export const DAILY_CHECK_IN_LIST_HISTORY = 'DAILY_CHECK_IN_LIST_HISTORY';
export const DAILY_CHECK_IN_LIST_RULE_SETTING = 'DAILY_CHECK_IN_LIST_RULE_SETTING';
export const DAILY_CHECK_IN_UPDATE_RULE_SETTING = 'DAILY_CHECK_IN_UPDATE_RULE_SETTING';